import type { IScenario } from 'commonTypes/api/scenarios/scenario';

import {
  deepNormalizeLineBreaksByDevice,
  getIsMobileViewport,
  hasLineBreakMarkersInTree,
} from 'shared/lib/deviceLineBreaks';

/**
 * Write-boundary для `setScenario`: в store кладём UI-ready тексты ([BREAK_MOBILE]/[BREAK_DESKTOP] → `\n`/пробел).
 * Формат `{ payload }` — контракт RTK `prepare`.
 */
export const prepareScenarioPayload = (scenario: IScenario): { payload: IScenario } => {
  if (!hasLineBreakMarkersInTree(scenario)) {
    return { payload: scenario };
  }

  return {
    payload: deepNormalizeLineBreaksByDevice(scenario, getIsMobileViewport()),
  };
};
